/**
 * Read a video file's duration (whole seconds) in the browser, for the presigned-upload
 * request's `durationSeconds` (surfaced later as the installation-guide video length).
 * Resolves `undefined` for non-video files or if the metadata can't be read — duration is
 * best-effort and never blocks an upload.
 */
export function readVideoDurationSeconds(file: File): Promise<number | undefined> {
  if (!file.type.startsWith('video/')) return Promise.resolve(undefined);

  return new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const video = document.createElement('video');
    const done = (value: number | undefined) => {
      URL.revokeObjectURL(objectUrl);
      resolve(value);
    };
    video.preload = 'metadata';
    video.onloadedmetadata = () =>
      done(Number.isFinite(video.duration) ? Math.round(video.duration) : undefined);
    video.onerror = () => done(undefined);
    video.src = objectUrl;
  });
}
